module.exports = __webpack_public_path__ + "imgs/emotion-member4@1x-min.c243f292.webp";